const navbar = {
  packages: "Paquets", // translated
  experiences: "Expériences", // translated
  close: "proche", // translated
  dashboard: "Tableau de bord", // translated
  pricing: "Tarifs", // translated
  hotDeals: "Bonnes affaires", // translated
  hotelPackages: "Forfaits hôteliers", // translated
};

export default navbar;
